import React from 'react';
import { motion } from 'framer-motion';
export function Newsletter() {
  return <section className="py-24 bg-primary-light" data-id="element-148">
      <div className="container mx-auto px-6" data-id="element-149">
        <div className="max-w-4xl mx-auto bg-primary-light rounded-3xl p-8 md:p-12 border border-primary-dark/5" data-id="element-150">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-151">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-152">
              <h2 className="text-4xl font-serif mb-4" data-id="element-153">
                Get your free
                <br data-id="element-154" />
                HVAC consultation
              </h2>
              <p className="text-sm text-primary-dark/70 leading-relaxed max-w-sm" data-id="element-155">
                Tell us about your commercial AC needs and we'll provide a
                no-obligation quote. From installations to TM44 compliance —
                we're here to help.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-156">
              <form className="relative" onSubmit={e => e.preventDefault()} data-id="element-157">
                <input type="email" placeholder="Your business email..." className="w-full bg-white rounded-full py-4 pl-6 pr-16 text-sm focus:outline-none focus:ring-2 focus:ring-accent/20 transition-shadow" required data-id="element-158" />
                <button type="submit" className="absolute right-2 top-2 bottom-2 aspect-square rounded-full flex items-center justify-center transition-transform hover:scale-110" data-id="element-159">
                  <img src="https://cdn.magicpatterns.com/uploads/fgnv4biGVj7edM7WhTC6GW/arrow-right-circle-blue.svg" alt="Submit" className="w-8 h-8" data-id="element-160" />
                </button>
              </form>
              <div className="mt-4 flex items-start gap-3" data-id="element-161">
                <input type="checkbox" id="consent" className="mt-1 rounded border-primary-dark/20 text-accent focus:ring-accent" data-id="element-162" />
                <label htmlFor="consent" className="text-xs text-primary-dark/60 leading-tight" data-id="element-163">
                  I accept that AccuTemp stores my email address to send service
                  updates and communications.
                </label>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}